module.exports = __webpack_public_path__ + "static/media/sculpture-5.9fd7c60e.jpg";